import axios from '@/api/axios';
import {toQueryString} from '@/api/queryString';
import type {
  AdminPaginatedEnvelope,
  AfriexAdmin,
  AfriexAdminQueryParams,
} from '@/types';

export const adminService = {
  getAdmins: async (
    filters: AfriexAdminQueryParams,
  ): Promise<AdminPaginatedEnvelope<AfriexAdmin[]>> => {
    const urlParams = toQueryString({page: 0, limit: 10, ...filters});
    const url = `/v2/admin/users/afriex-admins?${urlParams}`;
    const response =
      await axios.get<AdminPaginatedEnvelope<AfriexAdmin[]>>(url);
    return response.data;
  },
};
